import { render, staticRenderFns } from "./kaJunList.vue?vue&type=template&id=6dcf93f2&scoped=true&"
import script from "./kaJunList.vue?vue&type=script&lang=js&"
export * from "./kaJunList.vue?vue&type=script&lang=js&"
import style0 from "./kaJunList.vue?vue&type=style&index=0&id=6dcf93f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcf93f2",
  null
  
)

export default component.exports